import type { Components } from '@mui/material';

export const MuiTooltip: Components['MuiTooltip'] = {
  styleOverrides: {
    tooltip: {
      backgroundColor: '#363A3B',
      padding: '8px 6px',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '20px',
    },
    arrow: {
      color: '#363A3B',
    },
  },
};